import { Call02Icon, Mail01Icon, MessengerIcon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import { email } from 'src/constants';
import { getTel } from 'src/helpers';

const FloatingContact = () => {
	return (
		<div className='floating-contact'>
			<a href={`tel:${getTel()}`} className='fab phone' aria-label='Gọi hotline'>
				<span className='pulse' />
				<HugeiconsIcon icon={Call02Icon} size={22} />
			</a>
			<a
				href='https://m.me/pham.uc.509274'
				target='_blank'
				rel='noopener noreferrer'
				className='fab messenger'
				aria-label='Chat Messenger'
			>
				<HugeiconsIcon icon={MessengerIcon} size={22} />
			</a>
			<a href={`mailto:${email}`} className='fab mail' aria-label='Gửi email'>
				<HugeiconsIcon icon={Mail01Icon} size={20} />
			</a>
		</div>
	);
};

export default FloatingContact;
